import { IntegrationType } from 'generated/graphql';
import { capitalize } from 'lodash';

export const getDisplayNameForIntegrationType = (
  integrationType: IntegrationType,
) => {
  return capitalize(integrationType);
};
